import multiselectView from './multiselectComponent.html';
import './multiselectComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';
import { filterByStringFilter } from 'components/sharpr/filter/by/string/filterByStringFilter';

export function multiselectComponent() {
	return {
		bindings: {
			model: '=',
			items: '<',
			idField: '@?',
			labelField: '@?',
			onChange: '&',
			onClose: '&',
			maxRows: '<?',
			filterPlaceholder: '@?',
			defaultLabel: '@?',
			labelTemplate: '<?',
			flyoutLeft: '<?',
			flyoutRight: '<?',
			additionalProps: '=?',
		},
		controllerAs: 'vm',
		controller: multiselectComponentCtrl,
		template: multiselectView,
	};
}

export class multiselectComponentCtrl {
	constructor($scope, $element) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.$element = $element;
		// bind functions
		this.modelChange = _.throttle(this.modelChange.bind(this), 15, {
			leading: false,
			trailing: true,
		});
		this.filterItems = this.filterItems.bind(this);
		this.loadDropdownStyles = this.loadDropdownStyles.bind(this);
	}

	$onInit() {
		// save filterer
		this.filterer = filterByStringFilter();
		// setup defaults
		this.filterText = '';
		this.idField = this.idField || 'id';
		this.labelField = this.labelField || 'name';
		this.filterPlaceholder = this.filterPlaceholder || 'Filter...';
		this.isOpen = false;
		this.additionalProps = this.additionalProps || {};
		// handle checkboxes when
		this.$scope.$watch('vm.items', this.modelChange);
		this.$scope.$watch('vm.model', this.modelChange);
		this.$scope.$watch('vm.filterText', this.filterItems);
		this.$scope.$watchGroup(['vm.maxRows', 'vm.flyoutLeft', 'vm.flyoutRight'], this.loadDropdownStyles);
	}

	toggle() {
		if (this.isOpen && this.isDirty) {
			this.onClose && this.onClose();
		}
		this.isDirty = false;
		this.isOpen = !this.isOpen;
	}

	loadDropdownStyles() {
		const maxRows = this.maxRows || 20;
		const styles = {
			maxHeight: maxRows * 25 + 60 + 'px',
			minHeight: '60px',
		};
		if (this.flyoutLeft) {
			styles.left = -1 * this.flyoutLeft + 'px';
		}
		if (this.flyoutRight) {
			styles.right = -1 * this.flyoutRight + 'px';
		}
		this.dropdownStyles = styles;
	}

	modelChange() {
		if (!this.filteredItems) {
			this.filteredItems = ensure.array(this.items).slice(0);
		}
		this.update();
	}

	checkboxClick() {
		this.isDirty = true;
		this.update();
		this.onChange && this.onChange();
	}

	update() {
		const items = ensure.array(this.items);
		const chosen = ensure.array(this.model);
		this.hasSelectedAll = chosen.length === items.length;
		if (this.labelTemplate) {
			// we use ng-pluralize instead
			return;
		}
		// for the user activity page division multiselect
		if (Object.hasOwn(this.additionalProps, 'placeholder')) {
			return (this.label = `in any ${this.additionalProps.placeholder}`);
		}
		const label = [];
		chosen.forEach(id => {
			const found = _.find(items, { [this.idField]: id });
			if (found) {
				label.push(found[this.labelField]);
			}
		});
		this.label = label.join(', ');
	}

	filterItems() {
		this.filteredItems = this.filterer(this.items, this.labelField, this.filterText);
	}

	selectAll() {
		if (!Array.isArray(this.model)) {
			// model is not yet a valid array
			this.hasSelectedAll = false;
			return;
		}
		const items = ensure.array(this.filteredItems);
		const chosen = ensure.array(this.model);
		if (items.length === chosen.length) {
			// all are currently selected: unselect all
			this.hasSelectedAll = false;
			this.model.length = 0;
		} else {
			// none or some are selected: select all
			this.model.length = 0;
			this.hasSelectedAll = true;
			items.forEach(item => this.model.push(item[this.idField]));
		}
		this.checkboxClick();
	}
}
